import React, { useState } from 'react';
import { Flex, Text, Heading, Spinner } from '@chakra-ui/react';
import { Icon } from '@chakra-ui/icon';
import { MdOutlineRoute, MdArrowBack, MdOutlineLayers, MdChevronRight, MdMoreVert, MdMoreHoriz } from 'react-icons/md';
import InlineFormWrapper from '../../../components/inlineFormWrapper';
import SharedExperienceGroupNameForm from './sharedExperienceGroupNameForm';
import SharedExperienceListMenu from './sharedExperienceListMenu';
import { useNavigate } from 'react-router-dom';
export default function SharedExperienceListHeader({ 
  sharedExperience, 
  group, 
  parentGroup, 
  rights, 
  refreshList,
  experienceList,
  experienceGroupList,
  sharedExperienceList
}) {
  const [goingBack, setGoingBack] = useState(false);
  const navigate = useNavigate();
  const goBack = async () => {
    try {
      setGoingBack(true);
      await refreshList();
      setGoingBack(false);
          if(group?.group_id) {
      navigate(`/shared-experiences/${sharedExperience.id}?group-id=${group.group_id}`);
      } else {
        navigate(`/shared-experiences/${sharedExperience.id}`);
      }
    } catch (error) {
      console.error(error);
    }
  }
  return (
    <Flex
      alignItems='center'
      py={2}
      px={3}
      backgroundColor="white"
      justifyContent="space-between"
      h="54px"
    >
      <Flex alignItems="center">
        <Flex mr={3} alignItems='center'>
          {goingBack && (
            <Flex mr={3}>
              <Spinner />
            </Flex>
          )}
          {(!goingBack && group) && (
            <Icon
              as={MdArrowBack}
              boxSize="18px"
              mr={3}
              cursor="pointer"
              onClick={goBack}
            />
          )}
          <Flex 
            mr={2} 
            alignItems='center'
            cursor="pointer"
            onClick={() => {
              navigate(`/shared-experiences/${sharedExperience.id}`);
            }}
          >
            <Icon
              as={MdOutlineRoute}
              boxSize="18"
              mr={2}
            />
            <Heading variant="secondary">Experiences</Heading>
            {group && (
              <Icon
                as={MdChevronRight}
                boxSize="14px"
                ml={2}
                color="text.medium.grey"
              />
            )}
          </Flex>
          {group && (
            <Icon
              as={MdOutlineLayers}
              color="text.medium.green"
              boxSize="18"
              mr={2}
            />
          )}
          {parentGroup && (
            <>
              {parentGroup.group_id && (
                <>
                  <Flex
                    cursor="pointer"
                    onClick={() => {
                      navigate('/shared-experiences/' + sharedExperience.id + '?group-id=' + parentGroup.group_id)
                    }}
                  >
                    <Icon
                      as={MdMoreHoriz}
                      boxSize="18px"
                      mr={2}
                      color="text.light.green"
                      mt="10px"
                    />
                  </Flex>
                  <Icon
                    as={MdChevronRight}
                    boxSize="14px"
                    mr={2}
                    color="text.light.green"
                  />
                </>
              )}
              <Text
                color="text.light.green"
                fontWeight="500"
                fontSize="14px"
                mr={2}
                maxWidth="150px"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
                cursor="pointer"
                onClick={() => {
                  navigate('/shared-experiences/' + sharedExperience.id + '?group-id=' + parentGroup.group.id)
                }}
              >
                {parentGroup.group.name}
              </Text>
              <Icon
                as={MdChevronRight}
                boxSize="14px"
                mr={2}
                color="text.light.green"
              />
            </>
          )}
          <InlineFormWrapper
            width="100%"
            canEdit={rights?.can_update}
            value={
              <Text
                fontSize="18px"
                color="text.medium.green"
              >
                {group?.group?.name}
              </Text>
            }
          >
            {(close) => (
              <Flex pr={3}>
                <SharedExperienceGroupNameForm
                  groupId={group.id}
                  group={group.group}
                  onSubmitted={close}
                  onCancel={close}
                />
              </Flex>
            )}
          </InlineFormWrapper>
        </Flex>
        {rights?.can_update && (
          <SharedExperienceListMenu
            hasExperiences={!!(experienceList?.length || experienceGroupList?.length || sharedExperienceList?.length)}
            group={group}
            sharedExperienceId={sharedExperience.id}
            onNew={async () => {
              if (refreshList) await refreshList();
            }}
          />
        )}
      </Flex>
    </Flex>
  );
} 